(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8636],{

/***/ 60714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Example; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/views/Marketing/Blog/components/BlogPage/index.tsx
var BlogPage = __webpack_require__(32526);
// EXTERNAL MODULE: ./src/views/Marketing/components/Footer/index.tsx
var Footer = __webpack_require__(45867);
// EXTERNAL MODULE: ./src/views/Marketing/components/NavBar/index.tsx
var NavBar = __webpack_require__(82969);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/ScrollView/index.js
var ScrollView = __webpack_require__(38174);
var ScrollView_default = /*#__PURE__*/__webpack_require__.n(ScrollView);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__(84099);
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/views/Marketing/Blog/marketing/poshmark-offer-etiquette/index.tsx







function Page() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((ScrollView_default()), {
    style: styles.scrollView,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavBar/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(BlogPage/* default */.Z, {
      author: "OneShop Team",
      dateTime: "2021-08-03",
      tag: "Poshmark",
      title: "The Poshmark Offer Etiquette - A Step-by-Step Guide",
      children: ["\u200B", /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "The Poshmark platform is constantly evolving to accommodate more features to make the posher's purchase experience as seamless as possible. For Poshmark sellers, these features include different ways to adjust pricing which is convenient when you have to deal with the unfortunate fact that you\u2019ll get lowball offers when you sell clothes, accessories, and home goods on retail marketplaces like Poshmark, Mercari, and eBay."
      }), "\u200B", /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "When dealing with low ballers you need more than just good luck because keeping up with the proper seller\u2019s etiquette means that you need a strategy to handle low ball offers that allows you to keep your cool and most importantly convert some of these lowballers to customers."
      }), "\u200B \u200B", /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "What Is Considered a Lowball Offer?"
      }), "\u200B", /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Anything that is equal to or less than half of your asking price is considered to be a low ball offer. Poshers are always on the lookout for their favorite brands and styles but they want to purchase it for a great deal. New poshers should not get upset if they receive a lowball offer that has no interest in accepting a fair price because it just comes naturally with selling."
      }), "\u200B", /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "The Typical Low Ball Offer Reaction"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Low ball offers on Poshmark are not rare, in fact, the more items you have in your seller\u2019s closet, the more you will see low offers come in. If you\u2019re looking for a quick sale these lower offers can be tempting to just take what you can get, however, the typical response of many would be to scoff and click the decline button. Some might even hit back by responding with something mean about how these lowballers are wasting their time and being unfair with their low price."
      }), "\u200B", /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "How to Respond to Lowball Offers"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "As tempting as it might be, sellers should never react emotionally to these low ball offers because at the end of the day you as a seller are running a business and it should never be mixed with personal issues."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "For whatever reason, low ball offers will come in for all kinds of reasons and though as per community guidelines Poshmark offers are private although many times sellers and potential buyers will actually post a public exchange in the comments. This takes on the form of negotiating the lowest offer they can get from the asking price. Sometimes, sellers will try to sweeten the deal with shipping discounts, free gifts, and bundles."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "As long as you have a strategy for dealing with lowballers and don\u2019t ever let it get to you, Poshmark can be a pretty good side gig that can turn into a full-time job."
      }), "\u200B", /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Things to Consider With Low Ball Offers"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Meeting in the middle is the ideal strategy for both buyers and sellers even if the new buyer starts with a lower price. As a seller whose goal is to make a sale, you need to think about it from a buyer\u2019s perspective.", ' ']
      }), "\u200B", /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Buying items on Poshmark is not the same as buying them in a store"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Take for example, if you want to buy a designer pair of jeans for 30% off you can either wait for a department store to have a sale or go to outlet stores that will have a closet clear out. The fact is that a lot of items that are designer are being priced more competitively nowadays so if people want slightly discounted items new options are now available for them to buy in malls or online."
      }), "\u200B", /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Never negotiate in the comments section"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Only remember to answer questions about the item and any additional questions that could be helpful for other buyers to see in the listing but never talk about the price. Always give private discounts within your privacy because a potential buyer might get the wrong impression if they see back and forth negotiations in the comments of your listing then they might assume that your closet is open to haggling."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "You can direct questions about the price along the lines of \u201CThanks for checking out my closet! I\u2019m open to negotiating a reasonable offer so please feel free to make an offer\u201D."
      }), "\u200B", /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "You don\u2019t have to set garage sale prices, but always remember that most items depreciate quickly"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "On Poshmark, one of the best tips is to not use the manufacturer\u2019s suggested retail price as an anchor when listing items. The reason for this is because from a buyer\u2019s perspective no matter how fashionable an item was or still is, the fact is that it will depreciate over time. Sellers are always looking for a bargain so remember that even if you were thrifting and ecstatic that you paid 25% off a designer good it isn\u2019t always going to be the same care for your potential buyers."
      }), "\u200B", /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Don\u2019t Decline But Counter a Lowball Offer"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "If you don\u2019t accept low ball offers then what you can do is to give counteroffers instead of declining them and this needs to be based on your pricing strategy. As you should always counter a lowball offer with an acceptable price and be properly done with it. Poshmark is a marketplace for buying and selling clothes as it is a community that can be linked to social media platforms. Your interaction as a seller to potential buyers should always be friendly and positive so by giving a counter offer you are making an effort to negotiate with a buyer by not declining their offer."
      }), "\u200B", /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Here\u2019s a good message that you can say instead of outright declining an offer and after you\u2019ve gone back and forth with your counter offers:"
      }), "\u200B", /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("i", {
          children: "\u201CThank you for your offer! I wish I could accept, however, I need to consider my costs and the 20% selling fees on Poshmark. I can make one more counter offer but it\u2019s the best that I can do. Thank you for your consideration!\u201D"
        })
      }), "\u200B", /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "It shows respect to the potential buyer and as a seller, you are also expressing your gratitude for them browsing your Poshmark closet. And by not declining you are also avoiding giving potential buyers a bad experience with your shop and improving your star rating."
      }), "\u200B", /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Don\u2019t Be Afraid to Make it Known that You Stand Firm on Your Poshmark Pricing"
      }), "\u200B", /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "If you\u2019ve done your research and are confident with your listed price then don\u2019t be afraid to stand by it when confronted by a low baller. Another tactful way to handle low ball offers is by utilizing a price chart to determine a reasonable price offer that is below your asking price but not low enough to be considered a low ball offer."
      }), "\u200B", /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Consider Poshmark fees, shipping costs, and offer discount"
      }), "\u200B", /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Whatever counter offer you give should be profitable, always consider what your expected profit will be when you deduct posh fees, shipping discount/shipping costs (especially free shipping), and other offer discounts. As a seller, you should remember that profitability is the goal so be cautious of just how much of discount customers will get."
      }), "\u200B", /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Now that we\u2019ve gone over the Poshmark etiquette when it comes to creating offers. OneShop offers a helpful and easy automation tool that can act as your own sales marketing expert in handling shares, follows, and creating offers around the clock 24/7 for your Poshmark business", ' ']
      }), "\u200B", /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "OneShop gives you the advantage to market faster and more than the competition and get thousands of views from potential customers without you having to do anything. It features a built-in share jail protection that allows it to create human-like behavior to optimize your listings to be top of the search rankings and attract more active buyers."
      }), "\u200B", /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Give it a try and sign up for a free 7-day trial."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
}
var styles = StyleSheet_default().create({
  scrollView: {
    flex: 1
  }
});
;// CONCATENATED MODULE: ./src/pages/blog/poshmark-offer-etiquette.tsx





function Example() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "The Poshmark Offer Etiquette - A Step-by-Step Guide"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: "Your guide on politeness, etiquette, and getting the most out of your sales on Poshmark\u2019s Offer system!"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "canonical",
        href: "https://tools.oneshop.com/blog/poshmark-offer-etiquette"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:url",
        content: "https://tools.oneshop.com/blog/poshmark-offer-etiquette"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: "The Poshmark Offer Etiquette - A Step-by-Step Guide"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:description",
        content: "Your guide on politeness, etiquette, and getting the most out of your sales on Poshmark\u2019s Offer system!"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image",
        content: "https://tools.oneshop.com/static/images/og-image.png?v=4"
      }, 'og-image'), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:published_time",
        content: "2021-08-03T00:00:00.000Z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:modified_time",
        content: "2021-08-03T00:00:00.000Z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:tag",
        content: "Poshmark"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:publisher",
        content: "https://www.facebook.com/oneshopcompany"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Page, {})]
  });
}

/***/ }),

/***/ 88073:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/poshmark-offer-etiquette",
      function () {
        return __webpack_require__(60714);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,8409,8908,8776,8174,6770,1664,4965,9561,5675,1577,6554,858,275,9774,2888,179], function() { return __webpack_exec__(88073); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);